module.exports = __webpack_public_path__ + "static/img/76076B_1_C_20210408_LC.0557284.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/76076B_1_C_20210408_LC.png
// module id = Npx6
// module chunks = 0